<span
  #triggerRef
  class="inline-flex"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (focus)="onFocus()"
  (blur)="onBlur()"
>
  <ng-content></ng-content>
</span>

<div
  #floatingRef
  [style.position]="'fixed'"
  [style.top.px]="floatingStyles.top"
  [style.left.px]="floatingStyles.left"
  [style.z-index]="99999"
  [style.visibility]="isOpen ? 'visible' : 'hidden'"
  [style.pointer-events]="isOpen ? 'auto' : 'none'"
  [class]="
    'whitespace-nowrap rounded-lg px-3.5 py-2 text-xs font-medium shadow-md ' +
    variantClasses
  "
  role="tooltip"
>
  {{ content }}

  <div
    #arrowRef
    [style.position]="'absolute'"
    [style.width.px]="12"
    [style.height.px]="12"
    [style.transform]="'rotate(45deg)'"
    [style.top]="arrowStyles.top"
    [style.bottom]="arrowStyles.bottom"
    [style.left]="arrowStyles.left"
    [style.right]="arrowStyles.right"
    [class]="arrowBg + ' ' + arrowBorderSides + ' ' + arrowBorderClasses"
  ></div>
</div>
